import { Injectable, PipeTransform, Pipe,EventEmitter, NgZone, Directive, OnInit, Output } from '@angular/core';

import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from '@angular/material/snack-bar';
import { HttpClient,HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { MatDialog } from '@angular/material';
import { AlertComponent } from './alert/alert.component';
import { SuccessBoxComponent } from './components/success-box/success-box.component';
import { NativeDateAdapter } from '@angular/material';
import { MatDateFormats } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentViewerComponent } from './components/document-viewer/document-viewer.component';
import { PaymentPopupComponent } from './components/payment-popup/payment-popup.component';
import { BottomSheetOverviewExampleSheet } from './tabs/tabs.component';
import { ConfirmPopupComponent } from './sub-admin/confirm-popup/confirm-popup.component';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Helper {
  public user;
  notCounter=0;
   public applicationType;
   public ins_type;
   public permissions=[];

  //  globalAPiUrl = 'http://172.16.16.17/tveta_web/api/';
  //globalAPiUrl = 'https://demo.tveta.go.ke/tveta/api/';
  //  globalAPiUrl = 'https://demo.tveta.go.ke:8082/tveta/api/';
  //globalAPiUrl = 'http://dev.abnodemo.com/tveta_web/api/';
  // globalAPiUrl = 'https://mis.tveta.go.ke/uat/tveta_web/api/';
  // front_url= 'https://mis.tveta.go.ke/uat';

  //  globalAPiUrl = 'https://abnocloud.com/tveta/api/';
  // front_url = 'https://abnocloud.com/tveta_front';
  
    // globalAPiUrl = 'https://dev.abnodemo.com/tveta_uat_merge/api/';
  // globalAPiUrl = 'https://abnocloud.com/tveta/api/';
  
  globalAPiUrl = 'https://mis.tveta.go.ke/tveta/api/';
  front_url = 'https://mis.tveta.go.ke';
  
  // front_url= 'https://abnocloud.com/tveta_front';
  // globalAPiUrl = 'http://192.168.1.12/tveta_web/api/';

  // globalAPiUrl = 'http://172.16.16.21/tveta_web/api/';

  //  globalAPiUrl = 'http://172.16.16.21/TVETA/tveta_backend/api/';

   coursesUpdate:any = [];
   debug =true;
   payments={
      payment_code_key_for_trainer:{
          "initial-registration-and-licensing-of-trainer":"Initial registration and licensing of Trainer",
          "renewal-of-license-for-trainer": "Renewal of license for Trainer"
      },
      payment_code_key_for_institution:{
                "initial-registration-accreditation-and-licensing": "Initial registration, accreditation and licensing",
                "renewal-of-registration-accreditation-and-licensing": "Renewal of registration, accreditation and licensing",
                "addition-of-programmes": "Addition of programme(s)",
                "expansion-of-student-enrolment": "Expansion of Student Enrolment",
                "change-of-name-ownership-management": "Change of Name/Ownership/Management",
                "change-of-location":"Change of Location",
                "annual-qa-fee-per-student-enrolled": "Annual QA fee per student enrolled"

      },
   }
   settings={ ticketCounter:0,loader: false,dropdowns:{foreign_categories:[],
    trainer_reject_reason: [],
    trainer_records: [],
    training_standards: [],
    disabilities: [],
    free_courses:0,country_codes:[],pedagogy:[],director_roles:[],
    clusters:[],knqfs:[],horofics:[],qualifications:[],nationalities:[],
    languages:[],postal_codes:[],counties:[],sub_counties:[], institute_categories:[],
    building_types:[],
    exam_body:[],
    facilities:[],
    level:[],
    standard_evidence: [],
    tool_evidence: [],
    courses:[],
    safety_equipments:[],
    course_edit:{},reject_reason:[],
    washroom_conditions:[],
    room_conditions:[],
    water_sources:[],
    disposal_types:[],
    safety_euipments:[],
    safety_features:[],
    garbage_disposal:[],
    electrical_power:[],
    settings:[],
    HOME_PROCEDURE_PDF:null,
    area_of_specialization:[],
    trainer_application_type_listings:[],
    employment_status:[],
    payment_code:[],
    products:[],
    welcome_content:'',
    county_wards: []
  }};

    getButtonsUrl={
      'downloadCourseLIstAsPdf':this.globalAPiUrl+"admin/download-courses/pdf?token=",
      'downloadCourseLIstAsExcel':this.globalAPiUrl+"admin/download-courses/excel?token=",
      'downloadInstitutionListByStatusAsPdf':this.globalAPiUrl+"admin/download-institutions/pdf?",
      'downloadInstitutionListByStatusAsExcel':this.globalAPiUrl+"admin/download-institutions/pdf?",
  }





  constructor(private _snackBar: MatSnackBar,private http: HttpClient,
    public router:Router,
    private _zone: NgZone,
    private route: ActivatedRoute,


    public dialog: MatDialog) {
    this.user = new EventEmitter();
    this.ins_type = new EventEmitter();
    this.applicationType = new EventEmitter();
    this.registerZone();
  }

  showLoader(status){
    this.settings.loader=status;
  }

  registerZone(){
    window['angularComponentRef'] =this
  }

  setCurrentUrl(form,query){
  //   let params=(query)+Object.keys( form.value).map((key) =>{
  //     return encodeURIComponent(key) + '=' +
  //         encodeURIComponent(form.value[key]);
  // }).join('&')

  console.log(form,'form')

  form= Object.assign(form, JSON.parse('{"' + decodeURI(query.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}'));
  console.log(form,'form')
  this.router.navigate([], { relativeTo: this.route, queryParams: form, replaceUrl: true});
  }
  setUrlData(e,options:any={}){
    let val=JSON.parse(JSON.stringify(this.route.snapshot.queryParams));
console.log("setUrlData",val)
    if(val['page'])
    e.page=val['page'];
    if(val['per_page'])
    e.per_page=val['per_page'];
    if(val['sort_key'])
    e.sort.active=val['sort_key'];
    if(val['sort_order'])
    e.sort.direction=val['sort_order'];


    for(let parm in  val){

        if(options && options[parm] ){
          val[parm]= options[parm](val[parm]);
      }

        if(e.form.controls[parm]){
          e.form.controls[parm].setValue(val[parm])
        }

    }
  }
  toast(msg,color=null){
    if(!msg || msg=="" ){
      return 1;
    }
    let horizontalPosition: MatSnackBarHorizontalPosition = 'right';
   let verticalPosition: MatSnackBarVerticalPosition = 'top';
    var cls=color?{panelClass: ['red-snackbar','font-snack-bigger'],
    duration: 6000,horizontalPosition:horizontalPosition,verticalPosition:verticalPosition}:{
      panelClass: ['font-snack-bigger'],
      duration: 6000,
    }
    this._snackBar.open(msg, 'X',cls);

  }
  parseInt(val) {
    if (val == '') return 0;
    if (val == 'undefined') return 0;
    if (val == null) return 0;
    if (val == 'null') return 0;
    val = val.toString();
    return parseInt(val);
  }
  parseNumber(val) {
    if (val == '') return 0;
    if (val == 'undefined') return 0;
    if (val == null) return 0;
    if (val == 'null') return 0;
    val = val.toString();
    return parseFloat(val);
  }

  getCurrentRoute(form,url){
    let uri=this.router.url.split("/");
    if(uri.length==4){
      if(uri[1]=="institute" && uri[2]== "service" ){
        form.__page_service=uri[3];
        url= this.parseUrlAndAdd(url,"__page_service",uri[3])
        return url;
      }

    }
    return url;
  }

  parseUrlAndAdd(url,key,value){
    let parsed=this.router.parseUrl(url);
    if(Object.keys(parsed.queryParams).length>0)
      return (url+"&"+key+"="+value)
    else
    return (url+"?"+key+"="+value)

  }

  makeRequest(url,form,type="post",settings:any={toast:true,hideLoader:false}){
    let formData=form;
    url= this.getCurrentRoute(form,url);

      if(type=="postupload"){
        const uploadData = new FormData();
        for(let i in form){
          if(form[i] instanceof Blob)
            uploadData.append(i,form[i],form[i].name?form[i].name:"");
          else
            uploadData.append(i,form[i]);
        }
          formData=uploadData;
          type="post"
      }

      if(type=="postuploadarray"){
        const uploadData = new FormData();
        for(let i in form){
          if(form[i] instanceof Blob)
            uploadData.append(i,form[i],form[i].name?form[i].name:"");
            else if(form[i] instanceof Array){
              console.log(i,"is type of array");
              for(let arr in form[i]){
                if(typeof form[i][arr] =='object'){
                  for(let lst in form[i][arr]){
                    if(form[i][arr][lst] instanceof Blob){
                    console.log(""+i+"["+arr+"]["+lst+"]");
                      uploadData.append(""+i+"["+arr+"]["+lst+"]",form[i][arr][lst],form[i][arr][lst].name?form[i][arr][lst].name:"");
                    }
                    else{
                      uploadData.append(""+i+"["+arr+"]["+lst+"]",form[i][arr][lst]);
                    }
                  }
                }
                else{
                  uploadData.append(i,form[i]);
                }

              }
            }
            else
            uploadData.append(i,form[i]);
        }
          formData=uploadData;
          type="post"
      }



      formData.headers=new HttpHeaders({

        'Authorization': 'Bearer '+this.get("token")
      });



    if(!settings.hideLoader)
    this.showLoader(true);
    //"http://3.130.238.203/api/"

    return this.http[type](this.globalAPiUrl+url,formData,{headers:formData.headers})
    .pipe(map((data:any )=>  {
      if(settings.toast)
       this.toast( data.message)
       if(!settings.hideLoader)
        this.showLoader(false);
        (function removeNull(o) {
          for(var key in o) {
              if( null === o[key] || 'null' === o[key] ) o[key] = '';
              if ( typeof o[key] === 'object' ) removeNull(o[key]);
          }
       })(data);
      return data;

    })
    ,
    catchError((error)=> {
      console.log("error.status",error.status)
      if(error.status==440){
        let user=this.get("user");
        if(user){
          this.set("user",null);
          this.set("token",null);

          // this.showPopup("Session Timeout","Please login again to access your account");
          if(user.role_id==2 || user.role_id==5 || user.role_id==3)
            this.router.navigate(["/"])
          else
          this.router.navigate(["/admin"])
        }

      }
     // error.status==0?this.toast("Please check internet connection"):"";
     if(!settings.hideLoader)
      this.showLoader(false);
      return throwError(error);


  })
     );

  }

  ticketCounter=0;
  getNotifications()
  {
    let token=this.get("token");
    if(token){
      // let ev=new EventSource(this.globalAPiUrl+"notification-event?token="+token);
      // ev.onmessage=event=>{

      //   var msg=JSON.parse(event.data);
      //    this.notCounter= msg.msg;
      //   console.log(msg);
      // };



      this.makeRequest("admin/get-notification",{},"get",{toast:false,hideLoader:true})
      .subscribe(data=>{
        console.log(data.data)
        // this.notCounter=4;
        this.settings.ticketCounter=data.ticketCounter;
        this.notCounter=data.data;
        // if(data.data>0 && this.notCounter!=data.data){
        //   console.log(data.data)
        //   this.notCounter=data.data;
        //   // this.settings.ticketCounter=data.ticketCounter;
        //   var cls= {
        //     panelClass: ['font-snack-bigger'],
        //     duration: 6000,

        //   }
        //   console.log(cls)

        //   // this._snackBar.open("You have a new message",null,cls);

        // }

        setTimeout(()=>{
          this.getNotifications()
        },5000)
      },error=>{
        setTimeout(()=>{
          console.log(error);
         this.getNotifications()
       },60000);
      }
    )

    }
    else{
      setTimeout(()=>{
        this.getNotifications()
      },2000)
    }
  }
  getDropdowns(){
    this.makeRequest("getDropdowns",{},"get",{toast:false})
    .subscribe(data=>{
      console.log(data)
      this.settings.dropdowns=data.data;
      this.makeRequest("get-abn-products",{},"post",{toast:false})
    .subscribe(data=>{
      console.log(data)
      this.settings.dropdowns.products=data.products;
      var postals=[];
      for(let key in this.settings.dropdowns.postal_codes){
        let title="";
        if(!this.settings.dropdowns.postal_codes[key]["original_title"])
        this.settings.dropdowns.postal_codes[key]["original_title"]= this.settings.dropdowns.postal_codes[key]["title"];

        title= this.settings.dropdowns.postal_codes[key]["original_title"]+'('+this.settings.dropdowns.postal_codes[key]['postal_code']+')';

        postals.push({id:this.settings.dropdowns.postal_codes[key]["id"],title});
      }
      this.settings.dropdowns.postal_codes=postals;
      var apptypes={"trainer_new":{},"trainer_renew":{}};
      for(let codes of this.settings.dropdowns.payment_code){
        if(codes.code_applied_on=="TRAINER" && codes.service_name=="renewal-of-license-for-trainer"){
            apptypes["trainer_renew"][codes.trainer_application_type_id]=codes.code;
        }
        if(codes.code_applied_on=="TRAINER" && codes.service_name=="initial-registration-and-licensing-of-trainer"){
           apptypes["trainer_new"][codes.trainer_application_type_id]=codes.code;
        }

      }

      for(let key in this.settings.dropdowns.trainer_application_type_listings){

        this.settings.dropdowns.trainer_application_type_listings[key]["code"]= apptypes["trainer_new"][this.settings.dropdowns.trainer_application_type_listings[key].id];
        this.settings.dropdowns.trainer_application_type_listings[key]["renew_code"]= apptypes["trainer_renew"][this.settings.dropdowns.trainer_application_type_listings[key].id];

        for(let key2 in data.products){

          if(data.products[key2].code==this.settings.dropdowns.trainer_application_type_listings[key]["code"]){
            this.settings.dropdowns.trainer_application_type_listings[key]["amount_in_ksh"]=data.products[key2].price;
           }


          }
      }
     console.log(this.settings.dropdowns.trainer_application_type_listings,"this.settings.dropdowns.trainer_application_type_listings")


    })
    })

  }

  validationErrors(form){
    var errors=[]
    const controlErrors = form.errors;

    if (controlErrors != null) {

        Object.keys(controlErrors).forEach(keyError => {
          if(keyError=="required")
          errors.push("This field is required. ");
          else if(keyError=="email")
          errors.push("Email is not valid.");
          else if(keyError=="minlength")
           errors.push("This field should be greater than or equals to "+controlErrors[keyError].requiredLength+" characters. ");
           else if(keyError=="maxlength")
           errors.push("This field should be less than or equals to "+controlErrors[keyError].requiredLength+" characters. ");
           else if(keyError=="max")
           errors.push("This field should be less than "+controlErrors[keyError].max+". ");
           else if(keyError=="min")
            errors.push("This field should be greater than or equals to "+controlErrors[keyError].min+". ");

           else
           errors.push(keyError);
        });
    }


  return errors.length>0?errors[0]:"";
  }
  showServerErrors(err,form,cus=null){
    for(let i in err){
      console.log(err)
      if(form.controls[i]){
        form.controls[i].setErrors({[err[i]]: true})
      }
      if(cus && cus[i]){
        cus[i]=err[i];
      }
    }
  }
  likertScale = [{'id':'Not available',title:'Not available'},{'id':'Not complete',title:'Not complete'},{'id':'Satisfactory',title:'Satisfactory'},{'id':'To a large extent',title:'To a large extent'},{'id':'Excellent',title:'Excellent'}];

  set(key: string, data: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.error('Error saving to localStorage', e);
    }
  }
  checkUserAndRedirect(router,currentrole){
    let userStored=this.get("user");
    if(userStored){
      if(userStored.role_id == '2')
      {
          router.navigate(["/assessors/tabs"]);
      }
      else if(userStored.role_id == '5')
      {
          router.navigate(["/institute/tabs"]);
      }
      else if(userStored.role_id == '3')
      {
          router.navigate(["/curriculum/dashboard"]);
      }

      else{
          router.navigate(["/admin/dashboard"]);
      }
    }
  }
  get(key: string) {
    try {
      //console.log("get data for staff....");
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      console.log(key,'Error getting data from localStorage');
      return null;
    }
  }
  convertToDate(today,type=1){
    console.log(today,"todaytodaytoday")
    if(today instanceof Date){
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = today.getFullYear();
      if(type==1)
      today = dd + '-' + mm + '-' + yyyy;
      else
      today =  yyyy+ '-' + mm + '-' + dd;
    }
    else{

      var splitted = today.split("-"); // yyyy/mm/dd
      today = splitted[2] + '-' + splitted[1] + '-' + splitted[0]; //dd-mm-yyyy
    }
    return today;
  }
  me(cb?){
    this.makeRequest("assessor/me",{},"get",{toast:false}).subscribe((data)=>{

      this.set("user",data.data);
       if(cb){
         cb(data.data);
       }

  });
  }
  ins_me(cb?){
    this.makeRequest("institution/me",{},"get",{toast:false}).subscribe((data)=>{

      this.set("user",data.data);
       if(cb){
         cb(data.data);
       }

  });
  }
  getDropDownValue(dropdown,id,key="id",column="title"){
    let title="";
    for(let i of this.settings.dropdowns[dropdown]){
      if(i[key]==id)
        {
          title=i[column];
          break;
        }

    }
    return title;


  }
  JSONConvert(){
   return {
      parse:(value)=>{
        try{

            let newjson=JSON.parse(value);
            return newjson;

          }
          catch(err){
            return {d_length:"",d_width:"",value:""};
          }

        }
    };
  }
  JSONparse(){
    return {
       parse:(value)=>{
         try{

             let newjson=JSON.parse(value);
             return newjson;

           }
           catch(err){
             return {};
           }

         }
     };
   }
  getDimension(json){
    try{
      let newjson=JSON.parse(json);
      return newjson.d_length*newjson.d_width;

    }
    catch(err){
      return json;
    }

  }

  getDimensionKey(json,key){
    try{
      let newjson=JSON.parse(json);
      return newjson[key];

    }
    catch(err){
      return json;
    }

  }

  mapRoomConditions(fac){
    let room_conditions=[];
    if(fac){
        try{

          // let splitted = fac.split(",");
       let splitted=  'string' == typeof fac?fac.split(","):fac
        for(let i of splitted)
        //alert(i);
        room_conditions.push(this.getDropDownValue("room_conditions",parseInt(i)));
        }
        catch(e){
          room_conditions.push('parseError');
        }
    }
    return room_conditions.join(",");
  }


  mapProgrammeLevel(lev){
    let level = [];
    if(lev){
      try{
        let splitted = 'string' == typeof lev?lev.split(","):lev
        for(let i of splitted)
        level.push(this.getDropDownValue("level", this.parseInt(i)));
      }
      catch(e){
        level.push('parseError');
      }
    }
    return level.join(",");
  }

  mapStandardEvidence(se){
    let standard_evidence = [];
    if(se){
        standard_evidence.push(this.getDropDownValue("standard_evidence", this.parseInt(se)));

    }
    return standard_evidence.join(",");
  }

  mapToolEvidence(se){
    let tool_evidence = [];
    if(se){
      tool_evidence.push(this.getDropDownValue("tool_evidence", this.parseInt(se)));

    }
    return tool_evidence.join(",");
  }


  getDropDownRow(dropdown,id,key="id",column="title"){
    let row:any={};
    for(let i of this.settings.dropdowns[dropdown]){
      if(i[key]==id)
        {
          row=i ;
          break;
        }

    }
    return row;


  }
  successMessage(title,msg,cb,type='success'){
    const dialogRef = this.dialog.open(SuccessBoxComponent, {

      data: {msg:msg,title:title,type:type},
      maxWidth:'70vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      cb(result)
    });
  }

  test(data){

    this.showDocument(data,(a)=>{

    })
  }

  showDocument(data,cb){
    const dialogRef = this.dialog.open(DocumentViewerComponent, {

      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      cb(result)
    });

  }

  // show(data, param, cb){
  //   console.log(data);

  //   let sendData = {
  //     data: data,
  //     type: param
  //   }
  //   const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
  //     width: '400px',
  //     height: '250px',
  //     data: sendData
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     cb(result)
  //   });
  // }


  showAlert(cb){
    const dialogRef = this.dialog.open(AlertComponent, {

      data: null
    });

    dialogRef.afterClosed().subscribe(result => {
      cb(result)
    });
  }

  showPopup(title='TVETA',msg="",cb?){
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {

      data: {msg:title,content:msg,is_confirm:false}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(cb)
      cb(result)
    });
  }

  showConfirmPopup(title='TVETA',msg="",cb?){
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {

      data: {msg:title,content:msg,confirm_popup:true}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(cb)
      cb(result)
    });
  }

  getServerSentEvent(url: string): Observable<any> {
    return Observable.create(observer => {
      const eventSource = this.getEventSource(url);
      eventSource.onmessage = event => {
        console.log("event",event)
        this._zone.run(() => {
          observer.next(event);
        });
      };
      eventSource.onerror = error => {
        this._zone.run(() => {
          observer.error(error);
        });
      };
    });
  }
  private getEventSource(url: string): EventSource {
    return new EventSource(url);
  }
}

@Pipe({
  name: 'filter'
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], searchText: string,key:any="name"): any[] {

    if(!items) return [];
    if(!searchText) return items;

    searchText = searchText.toLowerCase();
  return items.filter( it => {

      if(key instanceof Array){
        if(key[1])
        return it[key[0]].toLowerCase().includes(searchText) || it[key[1]].toString().toLowerCase().includes(searchText);
        else
        return it[key[0]].toLowerCase().includes(searchText)
      }
      else
       return it[key].toLowerCase().includes(searchText);
    });
   }
}

@Pipe({
  name: 'truncate'
 })

 export class TruncatePipe implements PipeTransform {

 transform(value: string, args?: string[]): string {
   if(!value || value==""){
     return value;
   }
     const limit = args && args.length > 0 ? parseInt(args[0], 10) : 20;
     const trail = args &&  args.length > 1 ? args[1] : '...';
     return value.length > limit ? value.substring(0, limit) + trail : value;
    }
 }

 @Pipe({
  name: 'download'
 })

 export class DonwloadPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
 transform(value: string,url:string): string {
  // +value+
    if(typeof url=='string'){

    }
    else{
      url
      console.log(url,"datadata")
      url= URL.createObjectURL(url);

    }
     return this.sanitized.bypassSecurityTrustHtml( "<a  href='javascript:;' onclick='window[\"angularComponentRef\"].test(\""+url+"\")' data-title='aa'  >  Click to Preview</a> ") as string;
    }
    ngOnInit(){

    }
 }


 @Pipe({
  name: 'title_case'
 })

 export class TitleCasePipe implements PipeTransform {

  transform(str: string): string{
   return  str ? str.charAt(0).toUpperCase() + str.substr(1).toLowerCase() : '';
}
 }



export class AppDateAdapter extends NativeDateAdapter {


  format(date: Date, displayFormat: Object): string {
    var dp=new DatePipe("en-US");

    if (displayFormat === 'input') {
      return dp.transform(date,'dd MMM yyyy')
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: "numeric", day: "numeric" },
  },
  display: {
    dateInput: "input",
    monthYearLabel: { year: "numeric", month: "numeric" },
    dateA11yLabel: { year: "numeric", month: "long", day: "numeric"
    },
    monthYearA11yLabel: { year: "numeric", month: "long" },
  }
};


@Directive({
    selector: '[amInit]'
})
export class AmInitDirective implements OnInit {

    @Output()
    amInit: EventEmitter<any> = new EventEmitter();

    constructor(){
      console.log("ngInit")
    }
    ngOnInit() {
      console.log("ngInit")
        this.amInit.emit();
    }
}
